export const SIRENE_HELP_URL =
  'https://www.shine.fr/blog/obtenir-avis-situation-repertoire-sirene/';
export const KBIS_HELP_URL =
  'https://www.shine.fr/blog/numero-siret-extrait-kbis-apres-envoi-dossier-creation-entreprise/';
